export default "__VITE_ASSET__CvqpKLHM__"